module.exports = __webpack_public_path__ + "img/fault_task_bg.2a01fe5d.png";